// removed by extract-text-webpack-plugin
module.exports = {"loginFormCard":"LoginPage__loginFormCard--2ArsN","footer":"LoginPage__footer--3QYf6","root":"LoginPage__root--1bFVT","hasTextContent":"LoginPage__hasTextContent--3y_WR","loginWrapper":"LoginPage__loginWrapper--cRonL"};


//////////////////
// WEBPACK FOOTER
// ./src/client/src/components/pages/LoginPage.scss
// module id = 69
// module chunks = 0